export const CheckMarkblue = ({ color }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.83398 10.0625L6.00065 13.5L14.1673 2.5"
      stroke={color ? color : "#225AEA"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default CheckMarkblue
